import { createContext } from 'react';

const PickerContext = createContext({});

export default PickerContext;
